import styled from 'styled-components/macro';
import { Container } from '@yme/atoms/grid';
import { BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT, colorCoreBlack1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const GridWrapperStyled = styled.div `
  position: relative;

  ${ADAPTIVE.minWidth.desktop} {
    top: -${INDENT.xl};
  }
`;
export const ContainerStyled = styled(Container) `
  padding: ${INDENT.sm} 0;
  background: ${BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT};
  border-top: 4px solid ${colorCoreBlack1000};

  ${ADAPTIVE.minWidth.tablet} {
    border-top-width: 6px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: ${INDENT.xl} 0;
    border-top-width: 8px;
  }
`;
